export const DUMMY_IMG =
  "https://www.texasfamilyinstitute.org/editor/dudaone/images/placeholders/imgPlaceholder1.png";
